import { MantineSize } from "@mantine/core";
import Dropdown from "@ui/components/Dropdown/Dropdown";
import React, { FC, memo } from "react";
import { GridWrapper } from "../../registerVehicleWidgetStyle";
import { DropDownOption } from "@data/types";

type Props = {
  label?: string;
  labelId?: string;
  placeholder?: string;
  options?: DropDownOption[];
  size?: MantineSize;
  required?: true;
  withAsterisk?: true;
  searchable?: boolean;
  value?: string | null;
  onSelect?: (selectedValue: string | null) => void;
  onDropdownOpen?: () => void;
  headLabel: string;
  errorMessage?: string;
};

const CompanyFormDropdownMemo: FC<Props> = ({
  label = "",
  placeholder = "",
  options = [],
  size = "md",
  required,
  withAsterisk,
  searchable,
  value,
  onSelect,
  onDropdownOpen,
  headLabel,
  errorMessage,
}) => {
  return (
    <>
      <GridWrapper>
        <Dropdown
          value={value}
          required={required}
          withAsterisk={withAsterisk}
          label={label}
          placeholder={placeholder}
          options={options}
          size={size}
          searchable={searchable}
          onSelect={onSelect}
          onDropdownOpen={onDropdownOpen}
          errorMessage={errorMessage}
        />
      </GridWrapper>
    </>
  );
};

export const CompanyFormDropdown = memo(CompanyFormDropdownMemo);
